import { Controller } from "@hotwired/stimulus"
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

// Connects to data-controller="lightgallery"
export default class extends Controller {
  static targets = ["image"]

  plugin = lightGallery();
  dropplugin = lightGallery();

  connect() {
    this.plugin = lightGallery(this.element, {
      plugins: [lgZoom, lgThumbnail],
      licenseKey: '887FEC15-5F9F-4A1C-8415-B3D005E0C88B',
      speed: 500,
      selector: '.image',
    });
    this.dropplugin = lightGallery(this.element, {
      plugins: [lgZoom, lgThumbnail],
      licenseKey: '887FEC15-5F9F-4A1C-8415-B3D005E0C88B',
      speed: 500,
      selector: '.drop-image'
    });
  }

  disconnect() {
    this.plugin.destroy();
    this.dropplugin.destroy();
  }

}
